import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { tencentDocOpenUrlForAll } from '@tencent/tencent_doc_open_url';
import { DriveRequest } from "../common/drive-request";
export var OpenFileRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(OpenFileRequest, _DriveRequest);
  var _super = _createSuper(OpenFileRequest);
  function OpenFileRequest() {
    _classCallCheck(this, OpenFileRequest);
    return _super.apply(this, arguments);
  }
  _createClass(OpenFileRequest, [{
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              tencentDocOpenUrlForAll(payload);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function request(_x) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      return params;
    }
  }, {
    key: "getResult",
    value: function getResult() {
      return {
        url: this.params.url
      };
    }
  }]);
  return OpenFileRequest;
}(DriveRequest);
//# sourceMappingURL=open-file.js.map